var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardSetWidgetIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.492,
    height: 37.106,
    viewBox: "0 0 35.492 37.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chat-svgrepo-com",
    d: "M28.929,37.059A16.853,16.853,0,0,1,25.4,35.2a17.751,17.751,0,1,1,8.052-6.525c-.122,2.343,1.109,4.461,2.387,6.335,1.119,1.641.838,2.963-1.248,3.082A14.072,14.072,0,0,1,28.929,37.059ZM4.227,18.746a14.52,14.52,0,1,1,26.342,8.431c-.751,1.052-.365,3.023-.107,4.154a13.294,13.294,0,0,0,1.329,3.245,14.31,14.31,0,0,1-1.717-.534,13.933,13.933,0,0,1-3.488-1.968,1.613,1.613,0,0,0-1.669-.18A14.527,14.527,0,0,1,4.227,18.746Zm6.453-4.84a1.613,1.613,0,0,0,0,3.227H26.813a1.613,1.613,0,1,0,0-3.227Zm0,6.453a1.613,1.613,0,0,0,0,3.227H26.813a1.613,1.613,0,1,0,0-3.227Z",
    transform: "translate(-1 -1)",
    fill: "#c9c9c9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSetWidgetIcon);
export default __webpack_public_path__ + "static/media/dashboard-set-widget-icon.65198f0eb455d7151c3a4677be6f1805.svg";
export { ForwardRef as ReactComponent };